import * as React from 'react';

import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import ReadyForFullDegreeDefault from 'bundles/degree-home/components/v3-dpm/components/HelpTips/ReadyForFullDegreeDefault';
import ReadyForFullDegreePBAOnly from 'bundles/degree-home/components/v3-dpm/components/HelpTips/ReadyForFullDegreePBAOnly';
import { isFCND } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';
import useStudentSuccessAttributes from 'bundles/degree-home/components/v3-dpm/lib/useStudentSuccessAttributes';

const TipReadyForFullDegree = ({ learnerAdmissionStatus }: { learnerAdmissionStatus: LearnerAdmissionStatus }) => {
  const { studentSuccessAttributes } = useStudentSuccessAttributes();

  if (!isFCND(learnerAdmissionStatus) || !studentSuccessAttributes) {
    return null;
  }

  const { hasPbaAdmissionProcess, hasTraditionalAdmissionProcess } = studentSuccessAttributes;

  /** Whether the performance-based admissions process is the only way to get admitted into this program */
  const supportsPBAOnly = hasPbaAdmissionProcess && !hasTraditionalAdmissionProcess;

  if (supportsPBAOnly) {
    return <ReadyForFullDegreePBAOnly />;
  } else {
    return <ReadyForFullDegreeDefault />;
  }
};

export default TipReadyForFullDegree;
